var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B7\\u30E7\\u30C3\\u30D4\\u30F3\\u30B0\\u30D0\\u30C3\\u30B0",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.25,
    height: 30,
    viewBox: "0 0 26.25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shopping-bag",
    "data-name": "Icon awesome-shopping-bag",
    d: "M20.625,9.375V7.5a7.5,7.5,0,0,0-15,0V9.375H0V25.313A4.687,4.687,0,0,0,4.688,30H21.563a4.687,4.687,0,0,0,4.688-4.687V9.375ZM9.375,7.5a3.75,3.75,0,0,1,7.5,0V9.375h-7.5Zm9.375,7.031a1.406,1.406,0,1,1,1.406-1.406A1.406,1.406,0,0,1,18.75,14.531Zm-11.25,0a1.406,1.406,0,1,1,1.406-1.406A1.406,1.406,0,0,1,7.5,14.531Z",
    opacity: 0.298
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon_3.3a9104df8a87eac385cd96a275e3b7da.svg";
export { ForwardRef as ReactComponent };